// extracted by mini-css-extract-plugin
export default {"imageLogo":"AdminUserRoleEntity_imageLogo__dC-Q0","buttonSize":"AdminUserRoleEntity_buttonSize__lB0eH"};